import React from 'react';
import { Box, Button, Card, Container, Grid, Typography } from '@material-ui/core';

const PermitsCatalog = ({ sectionConfig = {}, layoutContext = {}, globalConfig = {} }) => {
    const {
        applyHoverEffect,
        removeHoverEffect,
        getIcon,
        getAnimationProps,
        handleHeroButtonClick
    } = layoutContext;

    const applyAnimation = (animationConfig, index = 0) => (
        typeof getAnimationProps === 'function' ? getAnimationProps(animationConfig, index) : {}
    );

    const sectionAnimation = applyAnimation(sectionConfig.animation?.section);
    const titleAnimation = applyAnimation(sectionConfig.animation?.title);
    const items = sectionConfig.items || [];

    const handleItemButtonClick = (itemButton = {}) => {
        if (itemButton.action && layoutContext.functionMap?.[itemButton.action]) {
            layoutContext.functionMap[itemButton.action]();
            return;
        }
        if (itemButton.action === 'handleSignUpClick') {
            layoutContext.handleSignUpClick?.();
            return;
        }
        handleHeroButtonClick?.(itemButton);
    };

    return (
        <Box
            id="permits-section"
            className={sectionAnimation.className}
            data-anim={sectionAnimation.dataAnim}
            data-delay={sectionAnimation.dataDelay}
            data-trigger-once={sectionAnimation.dataTriggerOnce}
            style={{ ...(sectionConfig.styles || {}), ...(sectionAnimation.style || {}) }}
        >
            <Container maxWidth={sectionConfig.container?.maxWidth || 'lg'}>
                {sectionConfig.title && (
                    <Typography
                        variant={sectionConfig.typography?.title?.variant || 'h3'}
                        className={titleAnimation.className}
                        data-anim={titleAnimation.dataAnim}
                        data-delay={titleAnimation.dataDelay}
                        data-trigger-once={titleAnimation.dataTriggerOnce}
                        style={{
                            ...(sectionConfig.titleStyles || {}),
                            ...(titleAnimation.style || {})
                        }}
                    >
                        {sectionConfig.title}
                    </Typography>
                )}

                {sectionConfig.subtitle && (
                    <Typography
                        variant={sectionConfig.typography?.subtitle?.variant || 'h6'}
                        style={sectionConfig.subtitleStyles || {}}
                    >
                        {sectionConfig.subtitle}
                    </Typography>
                )}

                <Grid
                    container
                    spacing={sectionConfig.grid?.spacing || 3}
                >
                    {items.map((item, index) => {
                        const cardAnimation = applyAnimation(sectionConfig.animation?.card, index);
                        return (
                            <Grid
                                key={`permit-card-${index}`}
                                item
                                xs={sectionConfig.gridItem?.xs || 12}
                                sm={sectionConfig.gridItem?.sm || 6}
                                md={sectionConfig.gridItem?.md || 4}
                                lg={sectionConfig.gridItem?.lg || 3}
                            >
                                <Card
                                    className={cardAnimation.className}
                                    data-anim={cardAnimation.dataAnim}
                                    data-delay={cardAnimation.dataDelay}
                                    data-trigger-once={cardAnimation.dataTriggerOnce}
                                    style={{
                                        ...(sectionConfig.cardStyles || {}),
                                        ...(item.cardStyles || {}),
                                        ...(cardAnimation.style || {})
                                    }}
                                    onMouseEnter={(e) => applyHoverEffect?.(e, sectionConfig.cardHoverStyles || {})}
                                    onMouseLeave={(e) => removeHoverEffect?.(e, { ...(sectionConfig.cardStyles || {}), ...(item.cardStyles || {}) })}
                                >
                                    <Box style={sectionConfig.cardContentStyles || {}}>
                                        {item.icon && (
                                            <Box
                                                style={{
                                                    ...(sectionConfig.iconContainerStyles || {}),
                                                    ...(item.iconContainerStyles || {}),
                                                    background: item.iconBackground || sectionConfig.iconContainerStyles?.background
                                                }}
                                            >
                                                {getIcon?.(item.icon, {
                                                    style: {
                                                        ...(sectionConfig.iconStyles || {}),
                                                        ...(item.iconStyles || {})
                                                    }
                                                })}
                                            </Box>
                                        )}

                                        <Typography
                                            variant={sectionConfig.typography?.cardTitle?.variant || 'h6'}
                                            style={{
                                                ...(sectionConfig.cardTitleStyles || {}),
                                                ...(item.titleStyles || {})
                                            }}
                                        >
                                            {item.title}
                                        </Typography>

                                        {item.description && (
                                            <Typography
                                                variant={sectionConfig.typography?.cardDescription?.variant || 'body2'}
                                                style={{
                                                    ...(sectionConfig.cardDescriptionStyles || {}),
                                                    ...(item.descriptionStyles || {})
                                                }}
                                            >
                                                {item.description}
                                            </Typography>
                                        )}

                                        {item.button && (
                                            <Box style={sectionConfig.cardButtonContainerStyles || {}}>
                                                <Button
                                                    variant={item.button.variant || sectionConfig.cardButton?.variant || 'contained'}
                                                    fullWidth={item.button.fullWidth !== undefined ? item.button.fullWidth : true}
                                                    style={{
                                                        ...(sectionConfig.cardButton?.styles || {}),
                                                        ...(item.button.styles || {})
                                                    }}
                                                    onMouseEnter={(e) => applyHoverEffect?.(e, item.button.hoverStyles || sectionConfig.cardButton?.hoverStyles || {})}
                                                    onMouseLeave={(e) => removeHoverEffect?.(e, { ...(sectionConfig.cardButton?.styles || {}), ...(item.button.styles || {}) })}
                                                    onClick={() => handleItemButtonClick(item.button)}
                                                    startIcon={item.button.icon ? getIcon?.(item.button.icon, { style: { fontSize: '1rem' } }) : null}
                                                >
                                                    {item.button.text || 'Apply'}
                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
};

export default PermitsCatalog;
